import getMatrixType from "@secureo/common/utils/getMatrixType"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"

export const toggleKeyComponentSelection = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuid: string,
) => {
	const { keyComponentsUuids, matrix } = reducerState

	const targetColumnIndex = keyComponentsUuids.findIndex(
		(componentUuid) => componentUuid === uuid,
	)
	const targetColumnHasSelectedAllComponents = matrix.reduce(
		(targetColumnHasSelectedAllComponents, matrixRow) => {
			return targetColumnHasSelectedAllComponents && matrixRow[targetColumnIndex]
		},
		true,
	)

	const updatedMatrix = matrix.map((matrixRow) => {
		const updatedMatrixRow = matrixRow
		updatedMatrixRow[targetColumnIndex] = !targetColumnHasSelectedAllComponents

		return updatedMatrixRow
	})

	const matrixType = getMatrixType(matrix)

	dispatch({
		type: "TOGGLE_COLUMN_SELECTIONS",
		payload: {
			matrix: updatedMatrix,
			matrixType,
		},
	})
}
